export const layersNameToLabel = (name: string): string => layers[name]?.label ?? `*${name}`
export const layersNameToClass = (name: string): string => layers[name]?.className ?? ''
export const layersLayerSupportsCount = (layerName: string): boolean => layers[layerName]?.supportsCallCount ?? true
export const layersLayerExists = (name: string): boolean => name in layers
export const layersDownstreamLayers = (): string[] => [...Object.keys(layers), 'remainder']

// PHP time is not measured on its own, it is the response time that is not spent in any downstream layer.
export const layersPhpResponseTime = (averageResponseTime: number, downstream: { [layer: string]: number } = {}): number => {
    if (downstream.php !== undefined) {
        return downstream.php
    }

    const downstreamResponseTime = Object.values(downstream).reduce((total, responseTime) => total + (responseTime || 0), 0)

    return Math.max(averageResponseTime - downstreamResponseTime, 0)
}

interface LayerConfiguration {
    label: string
    className: string
    supportsCallCount: boolean
}

// styling needs to be added via layers.less
// @see components/profiler/src/main/Xhprof/Bundle/ProfilerBundle/View/ProfileItem.php
const layers: { [layer: string]: LayerConfiguration } = {
    sql: { label: 'SQL', className: 'layer-sql', supportsCallCount: true },
    db: { label: 'SQL', className: 'layer-sql', supportsCallCount: true },
    http: { label: 'HTTP', className: 'layer-http', supportsCallCount: true },
    cache: { label: 'Cache', className: 'layer-cache', supportsCallCount: true },
    apcu: { label: 'APCu', className: 'layer-cache', supportsCallCount: true },
    mongo: { label: 'MongoDB', className: 'layer-mongo', supportsCallCount: true },
    redis: { label: 'Redis', className: 'layer-redis', supportsCallCount: true },
    queue: { label: 'Queue', className: 'layer-queue', supportsCallCount: true },
    es: { label: 'Elasticsearch', className: 'layer-es', supportsCallCount: true },
    al: { label: 'Autoloading', className: 'layer-io', supportsCallCount: true },
    email: { label: 'Email', className: 'layer-email', supportsCallCount: true },
    dns: { label: 'DNS', className: 'layer-dns', supportsCallCount: true },
    shell: { label: 'Shell', className: 'layer-shell', supportsCallCount: true },
    sleep: { label: 'Sleep', className: 'layer-sleep', supportsCallCount: false },
    gc: { label: 'Garbage Collection', className: 'layer-gc', supportsCallCount: true },
    session: { label: 'Session', className: 'layer-session', supportsCallCount: false },

    ct: { label: 'Compiling', className: 'layer-ct', supportsCallCount: true },

    io: { label: 'Non-CPU Time', className: 'layer-io', supportsCallCount: false },
    uio: { label: 'Unaccounted Wait', className: 'layer-io', supportsCallCount: false },
    fio: { label: 'File I/O', className: 'layer-io', supportsCallCount: false },
    runq: { label: 'Waiting for CPU', className: 'layer-runq', supportsCallCount: false },
}
